import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

const { blue, orange, midnight, carbon } = colorsPalettes;

const TotalVisitsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

const POPTotalVisitsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

const TotalAndTrafficWrapper = styled(FlexRow)`
    margin-top: 24px;
    height: 52px;
    justify-content: space-between;
    max-width: 325px;
    align-items: center;
`;

const TotalNumberStyled = styled.div`
    font-size: 45px;
    color: ${midnight["400"]};
    font-weight: 300;
`;

const ChangeContainer = styled(FlexRow)`
    margin-top: 8px;
    align-items: baseline;
    margin-left: 8px;
`;

const ChangeText = styled.div`
    font-size: 12px;
    margin-left: 8px;
    color: ${carbon[400]};
`;

export const POPChangeValueStyled = styled.div`
    align-self: center;
    .ChangeValue {
        font-size: 20px;
    }
`;

const BarChartContainer = styled(FlexRow)`
    width: 100%;
    margin-top: 16px;
    justify-content: center;
    align-items: end;
`;

const BarsContainer = styled(FlexRow)`
    height: 73px;
    margin: 0px 30px;
    justify-content: space-between;
    align-items: baseline;
    gap: 7px;
`;

export const POPVisitsItemBar = styled.div<{
    barHeight?: string;
    isCurrentPeriod?: boolean;
    width?: string;
}>`
    width: ${({ width }) => (width ? `${width}` : "28px")};
    height: ${({ barHeight }) => barHeight};
    background-color: ${({ isCurrentPeriod }) => (isCurrentPeriod ? blue[400] : orange[400])};
    border-radius: 2px;
`;

const TotalVisitsBodyContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 250px;
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
`;

const Bullet = styled.div<{ isCurrentPeriod?: boolean }>`
    background-color: ${({ isCurrentPeriod }) => (isCurrentPeriod ? blue[400] : orange[400])};
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
    flex-shrink: 0;
`;

const DateMetricWrapper = styled(FlexRow)`
    align-items: center;
`;
